import React, { useState } from 'react';
import { Link } from 'react-router-dom'

function Cart() {
    const [quantity, setQuantity] = useState(5); 
    const [quantity1, setQuantity1] = useState(1); 
    const [quantity2, setQuantity2] = useState(2); 
    const [quantity3, setQuantity3] = useState(3); 
    const [quantity4, setQuantity4] = useState(1);

    const decreaseQuantity = () => {
        if (quantity > 1) { 
            setQuantity(quantity - 1);
        }
    };
    const increaseQuantity = () => {
        setQuantity(quantity + 1);
    };

    const decreaseQuantity1 = () => {
        if (quantity1 > 1) { 
            setQuantity1(quantity1 - 1);
        }
    };
    const increaseQuantity1 = () => {
        setQuantity1(quantity1 + 1);
    };

    const decreaseQuantity2 = () => {
        if (quantity2 > 1) { 
            setQuantity2(quantity2 - 1);
        }
    };
    const increaseQuantity2 = () => {
        setQuantity2(quantity2 + 1);
    };

    const decreaseQuantity3 = () => {
        if (quantity3 > 1) { 
            setQuantity3(quantity3 - 1);
        }
    };
    const increaseQuantity3 = () => {
        setQuantity3(quantity3 + 1);
    };

    const decreaseQuantity4 = () => {
        if (quantity4 > 1) { 
            setQuantity4(quantity4 - 1);
        }
    };
    const increaseQuantity4 = () => {
        setQuantity4(quantity4 + 1);
    };

  return (
    <div>
    
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Cart</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" href="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Cart</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
    {/* <!-- Section Start --> */}
    <section className="section-padding pb-0">
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="table-responsive cart_table">
                        <table>
                            <thead>
                                <tr>
                                    <th className="remove-item"></th>
                                    <th>Product</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/1.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Power Drill</Link>
                                                </h6>
                                                <p className="mb-0">1pc</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$275.00</strong>
                                    </td>
                                    <td className="product_block product_details">
                                        <div className="product_action">
                                        <div className="quantity m-0">
                                            <button className="btn qty-mins" type="button" onClick={decreaseQuantity}>
                                                <i className="fal fa-minus"></i>
                                            </button>
                                            <input
                                                type="number"
                                                name="#"
                                                value={quantity}
                                                autoComplete="off"
                                                readOnly
                                            />
                                            <button className="btn qty-add" type="button" onClick={increaseQuantity}>
                                                <i className="fal fa-plus"></i>
                                            </button>
                                        </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$550.00</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/2.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Battery Drill</Link>
                                                </h6>
                                                <p className="mb-0">1pc</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$170.00</strong>
                                    </td>
                                    <td className="product_block product_details">
                                        <div className="product_action">
                                        <div className="quantity m-0">
                                            <button className="btn qty-mins" type="button" onClick={decreaseQuantity1}>
                                                <i className="fal fa-minus"></i>
                                            </button>
                                            <input
                                                type="number"
                                                name="#"
                                                value={quantity1}
                                                autoComplete="off"
                                                readOnly
                                            />
                                            <button className="btn qty-add" type="button" onClick={increaseQuantity1}>
                                                <i className="fal fa-plus"></i>
                                            </button>
                                        </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$170.00</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/3.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Hammer Drill</Link>
                                                </h6>
                                                <p className="mb-0">1pc</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$385.00</strong>
                                    </td>
                                    <td className="product_block product_details">
                                        <div className="product_action">
                                        <div className="quantity m-0">
                                            <button className="btn qty-mins" type="button" onClick={decreaseQuantity2}>
                                                <i className="fal fa-minus"></i>
                                            </button>
                                            <input
                                                type="number"
                                                name="#"
                                                value={quantity2}
                                                autoComplete="off"
                                                readOnly
                                            />
                                            <button className="btn qty-add" type="button" onClick={increaseQuantity2}>
                                                <i className="fal fa-plus"></i>
                                            </button>
                                        </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$770.00</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/4.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Circular Grinder</Link>
                                                </h6>
                                                <p className="mb-0">1pc</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$200.00</strong>
                                    </td>
                                    <td className="product_block product_details">
                                        <div className="product_action">
                                        <div className="quantity m-0">
                                            <button className="btn qty-mins" type="button" onClick={decreaseQuantity3}>
                                                <i className="fal fa-minus"></i>
                                            </button>
                                            <input
                                                type="number"
                                                name="#"
                                                value={quantity3}
                                                autoComplete="off"
                                                readOnly
                                            />
                                            <button className="btn qty-add" type="button" onClick={increaseQuantity3}>
                                                <i className="fal fa-plus"></i>
                                            </button>
                                        </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$200.00</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/5.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Electrical Grinder</Link>
                                                </h6>
                                                <p className="mb-0">1pc</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$80.00</strong>
                                    </td>
                                    <td className="product_block product_details">
                                        <div className="product_action">
                                        <div className="quantity m-0">
                                            <button className="btn qty-mins" type="button" onClick={decreaseQuantity4}>
                                                <i className="fal fa-minus"></i>
                                            </button>
                                            <input
                                                type="number"
                                                name="#"
                                                value={quantity4}
                                                autoComplete="off"
                                                readOnly
                                            />
                                            <button className="btn qty-add" type="button" onClick={increaseQuantity4}>
                                                <i className="fal fa-plus"></i>
                                            </button>
                                        </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$400.00</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="sidebar mb-xl-30">
                        <div className="input-group">
                            <input type="text" name="#" className="form-control form-control-custom" placeholder="Enter Coupon Code" autoComplete="off" required=""/>
                            <div className="input-group-append with_text">
                                <button type="submit">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Section End -->
    <!-- Section Start --> */}
    <section className="section pt-0">
        <div className="container-fluid">
            <div className="row justify-content-end">
                <div className="col-lg-6">
                    <div className="section-header">
                        <h3 className="title">Cart Total</h3>
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <th>Subtotal</th>
                                <td>90.99$</td>
                            </tr>
                            <tr>
                                <th>Tax</th>
                                <td> 9.99$ <span className="small">(11%)</span> </td>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <td> <b>99.99$</b> </td>
                            </tr>
                        </tbody>
                    </table>
                    <Link to="/checkout" className="thm-btn btn-rectangle thm-bg-color-one w-100">Proceed To Checkout</Link>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Cart